import React from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AllAcountsSection from "../../../Components/AllAccountsSection/AllAcountsSection";
import { AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import { AiFillCaretRight, AiOutlineRight } from "react-icons/ai";
import { useEffect, useState } from "react";
import axios from 'axios';
import { Link } from "react-router-dom";

const IzbAirForce = ({question,answer}) => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings_Banner.png";
const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Forex_Savings.png";

const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowLeft}
      className={className}
      style={{
        ...style,
        display: "block",
        width: "50px",
        height: "50px",
        left: "-58px",
        zIndex:"99"
      }}
      onClick={onClick}
    />
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <img
      src={ArrowRight}
      className={className}
 
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
}; 
  
  return (
    <>
      <Breadcrumb2
        Heading="Latest News"
        img={BackgroundBrundcrumb}
        show={true}
      
      />

        <section>
            <div className="container pt-5">
              <h1 className="pb-5 text-left">INDO ZAMBIA BANK AND ZAMBIA AIR FORCE: FORGING STRONGER PARTNERSHIPS</h1>

                <p className="pb-3">On 20th January 2025, Indo Zambia Bank Managing Director, Mr. Brajesh Kumar Singh accompanied by the General Manager Mr. Godwin C. Ngoma and his delegation, paid a courtesy call on the Zambia Air Force (ZAF) Commander, Lt. Gen. Oscar Msitu Nyoni, at the ZAF Headquarters to explore potential business collaborations.</p>

                <p className="pb-3">During the meeting, Lt. Gen. Nyoni highlighted ZAF’s role in contributing to Zambia’s food basket through commercial farming, as well as enhancing the nation’s tourism sector with the development of hospitality facilities in Mfuwe and Siavonga. He highlighted the need for financial partnerships to bring these capital-intensive projects to fruition, with the ultimate goal of empowering communities and improving personnel welfare.</p>

                <p className="pb-3">In response, Mr. Singh reaffirmed Indo Zambia Bank’s commitment to supporting such initiatives. He outlined tailored financial solutions to support agriculture ventures being undertaken by ZAF in response to the Presidential directive for ZAF to contribute to food production, including support with Smart Agriculture systems, low-interest Scheme loans for the men and women in uniform. Additionally, Lt. Gen. Nyoni invited the bank to collaborate on Corporate Social Responsibility (CSR) initiatives, such as supporting hospitals and schools through the Air Power Ladies Club.</p>

                <p className="pb-3"> Mr. Singh further stated that Indo Zambia Bank remained a proud and trusted partner of Zambia’s defense forces, steadfast in its commitment to serving as a catalyst for economic growth, driving national development, and fostering progress across the country.</p>      

              <h2 className="pt-4 pb-4">Gallery</h2>
            
              <div className="test news-slider-list-slider row align-items-center">
                <Slider {...settings}>
                  <div>
                    <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/INDO-ZAMBIA-BANK-AND-ZAMBIA-AIR-FORCE.jpg" alt="" />
                  </div>
                </Slider>
              </div>
            </div>

        </section>

      <CustomerCare />
      <OurStores />

    </>
  );
};

export default IzbAirForce;